export enum TeamDestructionAction {
	NewRetentionPeriod,
	Destroy,
	NoAction
}